export default class HighlightSearch {
	static init() {

		const input   = document.getElementById('q');
		const btnNext = document.getElementById('next');
		const btnPrev = document.getElementById('prev');
		const btnClear= document.getElementById('clear');

		if (!input || !btnNext || !btnPrev) return;

		const root =
			document.querySelector('[data-lexique-root]') ||
			document.querySelector('.item-container') ||
			document.querySelector('main') ||
			document.body;

		let hits = [];
		let index = -1;

		const escapeRegex = s => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

		function clearHighlights() {
			btnClear.classList.remove('visible');
			root.querySelectorAll('mark[data-hl]').forEach(mark => {
				const parent = mark.parentNode;
				if (!parent) return;
				while (mark.firstChild) parent.insertBefore(mark.firstChild, mark);
				parent.removeChild(mark);
				parent.normalize();
			});
			hits = [];
			index = -1;
		}

		// ➜ Snapshot des nœuds texte (on ne modifiera pas le DOM pendant la collecte)
		function collectTextNodes(container) {
			const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT, null);
			const nodes = [];
			let n;
			while ((n = walker.nextNode())) {
				// ignorer les textes à l’intérieur de nos propres surlignages
				const p = n.parentNode;
				if (p && p.nodeName === 'MARK' && p.hasAttribute('data-hl')) continue;
				// ignorer scripts/styles/champs/éléments invisibles
				if (p) {
					const t = p.tagName;
					if (t === 'SCRIPT' || t === 'STYLE' || t === 'NOSCRIPT' ||
						t === 'TEXTAREA' || t === 'INPUT' || t === 'SELECT' ||
						p.isContentEditable) continue;
					const cs = getComputedStyle(p);
					if (cs && (cs.display === 'none' || cs.visibility === 'hidden')) continue;
				}
				if (n.nodeValue && n.nodeValue.trim() !== '') nodes.push(n);
			}
			return nodes;
		}

		function highlightAll(term) {
			const q = term.trim();
			if (!q) { clearHighlights(); return; }
			clearHighlights();

			const textNodes = collectTextNodes(root); // <-- snapshot
			const newMarks = [];
			const pattern = new RegExp(escapeRegex(q), 'gi');

			for (const node of textNodes) {
				// le nœud peut avoir été retiré entre-temps
				if (!node.parentNode) continue;

				const text = node.nodeValue;
				if (!text) continue;

				// RegExp neuf par nœud pour éviter tout effet de lastIndex partagé
				const re = new RegExp(pattern.source, pattern.flags);
				if (!re.test(text)) continue;
				re.lastIndex = 0;

				const frag = document.createDocumentFragment();
				let last = 0, m;
				while ((m = re.exec(text)) !== null) {
					const start = m.index, end = start + m[0].length;
					if (start > last) frag.appendChild(document.createTextNode(text.slice(last, start)));
					const mark = document.createElement('mark');
					mark.setAttribute('data-hl', '');
					mark.textContent = text.slice(start, end);
					frag.appendChild(mark);
					newMarks.push(mark);
					last = end;
				}
				if (last < text.length) frag.appendChild(document.createTextNode(text.slice(last)));

				if (node.parentNode) node.parentNode.replaceChild(frag, node);
			}

			hits = newMarks;
			index = hits.length ? 0 : -1;
			selectCurrent();
			btnClear.classList.toggle('visible', hits.length);
		}

		function selectCurrent() {
			root.querySelectorAll('mark[data-hl].current').forEach(m => m.classList.remove('current'));
			if (index >= 0 && hits[index]) {
				const cur = hits[index];
				cur.classList.add('current');
				cur.scrollIntoView({ block: 'center', inline: 'nearest', behavior: 'smooth' });
			}
		}

		function next() {
			if (!hits.length) return;
			index = (index + 1) % hits.length;
			selectCurrent();
		}

		function prev() {
			if (!hits.length) return;
			index = (index - 1 + hits.length) % hits.length;
			selectCurrent();
		}

		// Events
		input.addEventListener('input', () => highlightAll(input.value));
		btnNext.addEventListener('click', next);
		btnPrev.addEventListener('click', prev);
		btnClear.addEventListener('click', () => {
			input.value = '';
			clearHighlights();
			input.focus();
		});
		input.addEventListener('keydown', e => {
			if (e.key === 'Enter') {
				e.preventDefault();
				e.shiftKey ? prev() : next();
			}
		});
	}
}
